var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "section" },
        [
          _c(
            "el-form",
            { attrs: { "label-position": "left", "label-width": "90px" } },
            [
              _c(
                "div",
                {
                  staticClass: "el-form-item-wrapper",
                  staticStyle: { display: "flex" }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_PlatformEnterpriseName")
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "150px", "padding-left": "10px" },
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.params.enterpriseName,
                          callback: function($$v) {
                            _vm.$set(_vm.params, "enterpriseName", $$v)
                          },
                          expression: "params.enterpriseName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { "padding-left": "10px" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.initEnterpriseInterfaceConfig }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("CargoMsg.Cargo_Query")) + " "
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.addHandler }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("CargoMsg.Cargo_Add")) + " "
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.statisticsHandle }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("CargoMsg.Cargo_Statistics")) +
                              " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c("div", { staticClass: "grid-view" }, [
        _c("div", { staticClass: "main-content" }, [
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              _c("cargo-ag-grid", {
                attrs: {
                  "config-module": "261603",
                  "grid-params": _vm.gridParams,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  },
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm.editDialog.visible
        ? _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.editDialog.visible,
                title: _vm.$t(
                  "CargoMsg.Cargo_PlatformEnterpriseInterfaceConfiguration"
                ),
                width: "580px",
                height: "580px",
                "close-on-click-modal": false,
                "append-to-body": ""
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.editDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  attrs: { "label-position": "right", "label-width": "120px" }
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 17 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_PlatformEnterpriseName"
                                ),
                                required: ""
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: !!_vm.editDialog.form.uuid,
                                  no: "1"
                                },
                                model: {
                                  value: _vm.editDialog.form.enterpriseName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editDialog.form,
                                      "enterpriseName",
                                      $$v
                                    )
                                  },
                                  expression: "editDialog.form.enterpriseName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 17 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_AccessKey"),
                                required: ""
                              }
                            },
                            [
                              _c("span", { attrs: { no: "2" } }, [
                                _vm._v(_vm._s(_vm.editDialog.form.accessKey))
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 17 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_SecretKey"),
                                required: ""
                              }
                            },
                            [
                              _c("span", { attrs: { no: "3" } }, [
                                _vm._v(_vm._s(_vm.editDialog.form.secretKey))
                              ]),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  attrs: {
                                    disabled: !!_vm.editDialog.form.uuid,
                                    type: "primary"
                                  },
                                  on: { click: _vm.generateSecretKey }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_AutomaticGenerated"
                                      )
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 17 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_EffectiveDate")
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "EffectiveDate",
                                  type: "date",
                                  placeholder:
                                    _vm.$t("CargoMsg.Cargo_Select") +
                                    _vm.$t("CargoMsg.Cargo_EffectiveDate")
                                },
                                model: {
                                  value: _vm.editDialog.form.beginDate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editDialog.form,
                                      "beginDate",
                                      $$v
                                    )
                                  },
                                  expression: "editDialog.form.beginDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 17 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_InvalidDate")
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "InvalidDate",
                                  type: "date",
                                  placeholder:
                                    _vm.$t("CargoMsg.Cargo_Select") +
                                    _vm.$t("CargoMsg.Cargo_InvalidDate")
                                },
                                model: {
                                  value: _vm.editDialog.form.endDate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editDialog.form,
                                      "endDate",
                                      $$v
                                    )
                                  },
                                  expression: "editDialog.form.endDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 17 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_CallBackUrl")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: !!_vm.editDialog.form.uuid,
                                  no: "4"
                                },
                                model: {
                                  value: _vm.editDialog.form.callBackUrl,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editDialog.form,
                                      "callBackUrl",
                                      $$v
                                    )
                                  },
                                  expression: "editDialog.form.callBackUrl"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.saveEnterpriseInterfaceConfig }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.editDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.statisticsDialog.visible
        ? _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.statisticsDialog.visible,
                title: _vm.$t("CargoMsg.Cargo_UsageStatistics"),
                width: "935px",
                height: "600px",
                "close-on-click-modal": false,
                "append-to-body": ""
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.statisticsDialog, "visible", $event)
                }
              }
            },
            [
              _c("cargo-ag-grid", {
                style: { width: "100%", height: "600px" },
                attrs: {
                  "config-module": "261604",
                  "grid-options": _vm.statisticsDialog.gridOptions,
                  "column-defs": _vm.statisticsDialog.columnDefs,
                  "row-data": _vm.statisticsDialog.rowData,
                  no: "1"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.statisticsDetailDialog.visible
        ? _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.statisticsDetailDialog.visible,
                title: _vm.$t("CargoMsg.Cargo_UsingFlowingWater"),
                width: "845px",
                height: "500px",
                "close-on-click-modal": false,
                "append-to-body": ""
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.statisticsDetailDialog, "visible", $event)
                }
              }
            },
            [
              _c("div", { staticStyle: { padding: "10px" } }, [
                _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("CargoMsg.Cargo_PlatformEnterpriseName") +
                          "：" +
                          _vm.statisticsDetailDialog.selectedData.enterpriseName
                      ) +
                      " "
                  )
                ]),
                _c("span", { staticStyle: { "margin-left": "30px" } }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("CargoMsg.Cargo_CallTemplateId") +
                          "：" +
                          _vm.statisticsDetailDialog.selectedData.templateUuid
                      ) +
                      " "
                  )
                ])
              ]),
              _c("cargo-ag-grid", {
                style: { width: "100%", height: "500px" },
                attrs: {
                  "config-module": "261605",
                  "grid-options": _vm.statisticsDetailDialog.gridOptions,
                  "column-defs": _vm.statisticsDetailDialog.columnDefs,
                  "row-data": _vm.statisticsDetailDialog.rowData,
                  no: "1"
                }
              }),
              _c(
                "div",
                { staticClass: "pagination-wrapper" },
                [
                  _c("cargo-pagination", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.statisticsDetailDialog.total > 0,
                        expression: "statisticsDetailDialog.total>0"
                      }
                    ],
                    attrs: {
                      "config-module": "261605",
                      total: _vm.statisticsDetailDialog.total,
                      page: _vm.statisticsDetailDialog.pageNum,
                      limit: _vm.statisticsDetailDialog.pageSize
                    },
                    on: {
                      "update:page": function($event) {
                        return _vm.$set(
                          _vm.statisticsDetailDialog,
                          "pageNum",
                          $event
                        )
                      },
                      "update:limit": function($event) {
                        return _vm.$set(
                          _vm.statisticsDetailDialog,
                          "pageSize",
                          $event
                        )
                      },
                      pagination: function($event) {
                        return _vm.statisticsDetailHandle()
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }